// userSlice.js
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { TLoginResponse } from "./types";

const DEFAULT_STORAGE_KEY = "userToken";

const userToken = localStorage.getItem(DEFAULT_STORAGE_KEY)
  ? localStorage.getItem(DEFAULT_STORAGE_KEY)
  : null;

const initialState = {
  loading: false,
  userInfo: null,
  userToken,
  error: null,
  success: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<TLoginResponse>) => {
      state.userToken = payload.accessToken;
      localStorage.setItem(DEFAULT_STORAGE_KEY, payload.accessToken);
    },
    clearUser: () => {
      localStorage.removeItem(DEFAULT_STORAGE_KEY);
      return {
        ...initialState,
        userToken: null,
      };
    },
  },
  extraReducers: {},
});

export const { setUser, clearUser } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
